<template>
  <div class="photo-book-listing">
    <div class="photo-book-header">
      <h1>My Life Books</h1>
      <div class="header-actions">
        <button class="create-book-button" @click="handleCreateNewBook">
          <img src="../../assets/Svg/add-book.svg" alt="Add" />
          <span>Create New Book</span>
        </button>
      </div>
    </div>

    <div class="info-box" v-if="showSubscriptionInfo">
      <div class="info-box-heading">Get Unlimited Books</div>
      <p>
        Subscribe to our plan and create unlimited books to keep your greatest
        memories alive. You can get your book printed and delivered at your
        doorstep.
      </p>
    </div>

    <div class="col-12 p-0" v-if="showLoader == 1">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-3 mt-md-4 pr-md-0">
          <div class="products-list-shim bordered-loader">
            <content-placeholders :rounded="true">
              <content-placeholders-img />
              <content-placeholders-heading />
              <content-placeholders-text :lines="3" />
            </content-placeholders>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 mt-4 pr-md-0">
          <div class="products-list-shim bordered-loader">
            <content-placeholders :rounded="true">
              <content-placeholders-img />
              <content-placeholders-heading />
              <content-placeholders-text :lines="3" />
            </content-placeholders>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 mt-4 pr-md-0">
          <div class="products-list-shim bordered-loader">
            <content-placeholders :rounded="true">
              <content-placeholders-img />
              <content-placeholders-heading />
              <content-placeholders-text :lines="3" />
            </content-placeholders>
          </div>
        </div>
        <div class="col-12 col-md-6 col-lg-3 mt-4 pr-md-0 pr-lg-3">
          <div class="products-list-shim bordered-loader">
            <content-placeholders :rounded="true">
              <content-placeholders-img />
              <content-placeholders-heading />
              <content-placeholders-text :lines="3" />
            </content-placeholders>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="books-grid" v-if="books.length > 0">
        <div
          class="book-item"
          v-for="(book, index) in books"
          :key="index"
          @click="goToBook(book.guid)"
        >
          <div class="book-cover">
            <img :src="book.coverPreview" v-if="book.coverPreview" />
            <div v-else class="no-cover">No preview available.</div>
          </div>
          <div class="book-info">
            <div class="book-title">{{ book.title }}</div>
            <div class="book-date" v-if="book.date">{{ book.date }}</div>
          </div>
        </div>
      </div>
      <div v-else class="no-books-placeholder">
        No Book available.
      </div>
    </div>

    <!-- Vue Modal instead of Bootstrap Modal -->
    <div v-if="showModal" class="modal-overlay" @click="closeModal">
      <div class="modal-dialog modal-dialog-centered modal-lg custom-vue-modal">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h6 class="modal-title">Create Life Book</h6>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeModal"
            >
              <img src="../../assets/Svg/close.svg" alt="" />
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <input
                v-model.trim="$v.bookTitle.$model"
                type="text"
                id="text"
                class="form-control"
                required
                @keyup="errorNullIndividual()"
                :class="{
                  'is-invalid': $v.bookTitle.$error,
                  'is-valid': !$v.bookTitle.$invalid,
                }"
                trim
                spellcheck="false"
                autocomplete="off"
              />
              <span class="placeholder">Title</span>
              <div v-if="!$v.bookTitle.required" class="invalid-tooltip">
                Book title is required
              </div>
            </div>
            <div class="event-btns-wrapper justify-content-end">
              <button
                type="button"
                class="btn btn-primary"
                v-on:click="createBook(0)"
                :disabled="isLoadingArraySingle[0]"
              >
                <div v-if="isLoadingArraySingle[0]" class="lds-dual-ring"></div>
                <span class="d-block" v-else>
                  <img src="../../assets/Svg/save.svg" alt="save" />
                  Save
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { fabric } from "fabric";
import { required } from "vuelidate/lib/validators";
export default {
  name: "MyLifeBooks",
  data() {
    return {
      bookTitle: "",
      isDisabledIndividual: true,
      isLoadingArraySingle: [],
      books: [],
      showSubscriptionInfo: true,
      showFilterOptions: false,
      showLoader: 1,
      encryptedKey: null,
      customerSessionSecret: "",
      showModal: false, // Vue modal control
    };
  },
  validations: {
    bookTitle: { required },
  },
  mounted() {
    this.checkPRoUser();
    this.fetchBooks();
  },
  methods: {
    async checkPRoUser() {
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}getUrlforPackages`
        );

        // Update the encrypted key if available
        if (response.data.data.encrypted_email) {
          this.encryptedKey = response.data.data.encrypted_email;
          this.proExpiry = response.data.data.expiryDate;
          this.proStatus = response.data.data.proStatus;
          this.noSubscriptionAvailed = response.data.data.noSubscriptionAvailed;
          this.subscriptionPlan = response.data.data.subscriptionPlan;
        } else {
          console.error("No encrypted email received from API");
        }

        // Extract customer session secret from the getPackageUrl string
        if (response.data.data.getPackageUrl) {
          // Expected URL format:
          // http://localhost:8080/go-pros/{encryptedEmail}/customer-session-link/{client_secret}
          const parts = response.data.data.getPackageUrl.split(
            "/customer-session-link/"
          );
          if (parts.length > 1) {
            this.customerSessionSecret = parts[1];
          } else {
            console.error("Customer session secret not found in getPackageUrl");
          }
        } else {
          console.error("No getPackageUrl received from API");
        }
      } catch (error) {
        console.error("Error fetching encrypted email:", error);
      }
    },
    handleCreateNewBook() {
      if (this.proStatus !== 1 && this.books.length >= 1) {
        // Free user with 1 book - show upgrade modal
        this.$fire({
          title:
            "Free users can create only one book. Upgrade to Pro to create unlimited books.",
          showCancelButton: true,
          confirmButtonText: "Go Pro",
          cancelButtonText: "Cancel",
        }).then((result) => {
          if (result.dismiss === "cancel" || result.dismiss === "backdrop") {
            return; // Prevents redirection
          }
          // Redirect only if "Go Pro" is clicked
          this.$router.push({
            path: `/go-pro/${this.encryptedKey}/customer-session-link/${this.customerSessionSecret}`,
          });
        });
        return;
      } else {
        // Pro user or free user with 0 books - open modal
        this.showModal = true; // Vue modal control
      }
    },
    goToBook(guid) {
      if (guid) {
        this.$router.push(`/my-life-book/${guid}`);
      }
    },
    errorNullIndividual() {
      // Check if title is not empty
      this.isDisabledIndividual = this.bookTitle.trim() == "";
    },
    async fetchBooks() {
      this.showLoader = 1;
      try {
        const response = await axios.post(
          `${process.env.VUE_APP_API_URL}lifebook/index`
        );
        if (response.data.statusCode === 200) {
          this.books = await Promise.all(
            response.data.data.map(async (book) => ({
              ...book,
              coverPreview: await this.generateCoverImage(book),
            }))
          );
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
      } finally {
        this.showLoader = 0;
      }
    },

    async generateCoverImage(book) {
  if (!book.pages?.length) return null;

  const firstPage = book.pages[0];
  if (!firstPage.content_json) return null;

  try {
    const canvasEl = document.createElement("canvas");
    const content = JSON.parse(firstPage.content_json);

    // Ensure all images are loaded with CORS
    if (content.objects) {
      content.objects.forEach(obj => {
        if (obj.type === "image") {
          obj.crossOrigin = "anonymous";
        }
      });
    }

    const targetWidth = 320;
    const targetHeight = 230;

    const originalWidth = content.canvasWidth || 617;
    const originalHeight = content.canvasHeight || 423;

    canvasEl.width = targetWidth;
    canvasEl.height = targetHeight;

    return new Promise((resolve) => {
      const fabricCanvas = new fabric.StaticCanvas(canvasEl);

      fabricCanvas.loadFromJSON(content, () => {
        const scaleX = targetWidth / originalWidth;
        const scaleY = targetHeight / originalHeight;
        const scale = Math.min(scaleX, scaleY);

        fabricCanvas.getObjects().forEach((obj) => {
          obj.scaleX *= scale;
          obj.scaleY *= scale;
          obj.left *= scale;
          obj.top *= scale;
          obj.setCoords();
        });

        if (scaleX > scaleY) {
          const offsetX = (targetWidth - originalWidth * scale) / 2;
          fabricCanvas.getObjects().forEach((obj) => {
            obj.left += offsetX;
            obj.setCoords();
          });
        } else {
          const offsetY = (targetHeight - originalHeight * scale) / 2;
          fabricCanvas.getObjects().forEach((obj) => {
            obj.top += offsetY;
            obj.setCoords();
          });
        }

        fabricCanvas.renderAll();
        resolve(
          fabricCanvas.toDataURL({
            format: "png",
          })
        );
        fabricCanvas.dispose();
      });
    });
  } catch (error) {
    console.error("Error generating cover preview:", error);
    return null;
  }
},
    async createBook(index) {
      this.$v.$touch();
      if (this.$v.$pendding || this.$v.$error) return;
      this.isDisabledIndividual = true;
      this.$set(this.isLoadingArraySingle, index, true);
      const formData = new FormData();
      formData.append("title", this.bookTitle);

      try {
        const response = await axios.post(
          process.env.VUE_APP_API_URL + "lifebook/store",
          formData
        );

        if (response.data.statusCode === 200) {
          const guid = response.data.data?.guid;
          this.$set(this.isLoadingArraySingle, index, false);
          this.closeModal();
          if (guid) {
            // Redirect to the new book's page
            this.$router.push(`/my-life-book/${guid}`);
          }
        } else {
          this.$set(this.isLoadingArraySingle, index, false);
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
        this.$set(this.isLoadingArraySingle, index, false);
      } finally {
        this.$set(this.isLoadingArraySingle, index, false);
      }
    },
    closeModal() {
      // Close the Vue modal
      this.showModal = false;
      this.resetForms();
    },
    resetForms() {
      // Reset form data
      this.$v.$reset();
      this.bookTitle = "";
      this.isDisabledIndividual = true;
    },
  },
};
</script>
